import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-country-indetifiers',
  templateUrl: './new-country-indetifiers.component.html',
  styleUrls: ['./new-country-indetifiers.component.scss'],
})
export class NewCountryIndetifiersComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  isReadOnly = false;
  countryIndetifiersParameterData: any;
  countryIndetifiersAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  regionList: any;
  selectRegion: any;

  @Output() saveNewCountryIndetifiersEvent = new EventEmitter<any>();

  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isReadOnly =
      this.modalLabel.toLowerCase() == 'review country identifiers detail' ? true : false;
    this.countryIndetifiersParameterData =
      this.modal?.modalService?.config?.initialState?.['newCountryIndetifiersData'];
    this.regionList = this.countryIndetifiersParameterData.regionItems;
    this.getRegionData();
  }

  ngOnInit(): void {
    this.countryIndetifiersAddEditForm = this.formBuilder.group({
      country: [
        this.countryIndetifiersParameterData.countryIdentifier?.countryName || '',
        Validators.required,
      ],
      region: [null, Validators.required],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.countryIndetifiersParameterData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }
  setFormData() {
    this.countryIndetifiersAddEditForm.patchValue({ region: this.selectRegion });
  }

  commonInputSearch(term: string, item: any) {
    return item.name?.toLowerCase().includes(term.toLowerCase());
  }

  onSave() {
    this.submitted = true;
    if (
      this.countryIndetifiersAddEditForm.invalid ||
      this.countryIndetifiersAddEditForm.controls['region'].value?.name == 'Region'
    ) {
      return;
    }
    const savecountryIndetifiersData = {
      countryName: this.countryIndetifiersAddEditForm.controls['country'].value,
      associatedRegionId:
        this.countryIndetifiersAddEditForm.controls['region'].value?.id ||
        this.countryIndetifiersParameterData.regionId,
    };
    this.saveNewCountryIndetifiersEvent.emit(savecountryIndetifiersData);
  }
}
